import { render, staticRenderFns } from "./InputNumeroDocumento.vue?vue&type=template&id=5877ed09&"
import script from "./InputNumeroDocumento.vue?vue&type=script&lang=js&"
export * from "./InputNumeroDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports